export default __webpack_public_path__ + "static/media/feature-image3.a88ccb05.png";